<template>
    <div>
        <a :href="'https://finance.yahoo.co.jp/quote/'+code" target="_blank">Y</a> 
        <a :href="'http://kabu3.freebbs.biz/shikihos/'+code" target="_blank">四</a> 
        <a :href="'http://kabu3.freebbs.biz/histories/'+code" target="_blank">価</a> 
        <a :href="'https://www.invest-jp.net/yuutai/detail/'+code" target="_blank">逆</a> 
        <a :href="'http://www.nisshokin.com/'+code" target="_blank">証</a>
        <a :href="'http://kabu3.freebbs.biz/crosses/'+code" target="_blank">カ</a> 
        <a :href="'http://kabu3.freebbs.biz/crosses/smbc/'+code" target="_blank">S</a> 
        <a :href="'https://96ut.com/stock/index.php?code='+code" target="_blank">玄</a> 
        <a :href="'https://gokigen-life.tokyo/'+code+'yutai/'" target="_blank">手</a> 
    </div>
</template>

<script>
export default {
    props: ["code"],
}
</script>